<div matDialogTitle>{{(unmatchedDepartments) ? "Invalid Department Codes" : "Invalid Sub Department Codes"}}</div>

@if (unmatchedDepartments) {
  <mat-dialog-content>
    <div class="modal-text">These Assets cannot be imported because we did not recognize the following Departments:</div>
    <div class="modal-text">{{unmatchedDepartments.replace('\'', '')}}</div>
    <div class="modal-text">A Studio user must add the Departments to the Studio before these Assets can be imported.</div>
  </mat-dialog-content>
}
@if (unmatchedSubDepartments) {
  <mat-dialog-content>
    <div class="modal-text">These Assets cannot be imported because we did not recognize the following Sub Departments:</div>
    <div class="modal-text">
      @for (unmatchedSubDepartment of unmatchedSubDepartments; track unmatchedSubDepartment; let last = $last) {
        {{unmatchedSubDepartment.department.replaceAll('\'', '')}}-<span class="sub-department">{{unmatchedSubDepartment.subDepartment.replaceAll('\'', '')}}</span>{{(!last) ? ', ' : '' }}
      }
    </div>
    <div class="modal-text">A Studio user must add the Sub Departments to the Studio before these Assets can be imported.</div>
  </mat-dialog-content>
}
<div class="flex justify-flex-end gap-20">
  <button mat-raised-button [mat-dialog-close]="true" >Cancel</button>
</div>
